module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-dialog', {
    ref: "createProj",
    attrs: {
      "md-open-from": "#createProj",
      "md-close-to": "#createProj"
    },
    on: {
      "open": _vm.fixContent,
      "close": _vm.startOver
    }
  }, [(_vm.canCreateProject) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('create', {
    attrs: {
      "project": _vm.project
    },
    on: {
      "update:isAllInputsFilled": _vm.handleInputFill,
      "close-dialog": _vm.closeDialogModel
    }
  }), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticStyle: {
      "color": "red",
      "margin-top": "10px",
      "word-wrap": "break-word",
      "overflow-wrap": "break-word",
      "word-break": "break-all",
      "width": "385px",
      "padding-left": "10px",
      "padding-right": "10px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.errorMessage) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isAllInputsFilled) ? _c('md-button', {
    staticClass: "md-raised md-primary",
    staticStyle: {
      "margin-bottom": "25px"
    },
    attrs: {
      "disabled": !_vm.isAllInputsFilled,
      "type": "button"
    }
  }, [_vm._v("Create")]) : _c('md-button', {
    staticClass: "md-primary md-raised",
    staticStyle: {
      "margin-bottom": "25px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("Create")])], 1) : _c('div', [_c('md-dialog-title', [_vm._v("Create a project")]), _vm._v(" "), _c('md-dialog-content', [_vm._v("You need an active plan to create a project. Upgrade from your account to start a new production.")]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Ok")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8dab40d6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/create-project.vue
// module id = 1277
// module chunks = 21